// Biblioteca de Widgets Pré-Configurados

export const COMPANY_WIDGETS = [
  {
    id: 'tickets-by-status',
    type: 'bar_chart',
    title: 'Tickets por Status',
    dataSource: 'tickets',
    icon: '📊',
    config: {
      groupBy: 'status',
      metric: 'count',
      filters: {},
    },
    defaultPosition: { x: 0, y: 0, w: 8, h: 4 },
  },
  {
    id: 'tickets-by-priority',
    type: 'pie_chart',
    title: 'Tickets por Prioridade',
    dataSource: 'tickets',
    icon: '🥧',
    config: {
      groupBy: 'priority',
      metric: 'count',
    },
    defaultPosition: { x: 8, y: 0, w: 4, h: 4 },
  },
  {
    id: 'total-tickets',
    type: 'metric_card',
    title: 'Total de Tickets',
    dataSource: 'tickets',
    icon: '🎫',
    config: {
      metric: 'count',
    },
    defaultPosition: { x: 0, y: 4, w: 3, h: 2 },
  },
  {
    id: 'total-users',
    type: 'metric_card',
    title: 'Total de Usuários',
    dataSource: 'users',
    icon: '👥',
    config: {
      metric: 'count',
    },
    defaultPosition: { x: 3, y: 4, w: 3, h: 2 },
  },
  {
    id: 'total-customers',
    type: 'metric_card',
    title: 'Total de Clientes',
    dataSource: 'customers',
    icon: '🏢',
    config: {
      metric: 'count',
    },
    defaultPosition: { x: 6, y: 4, w: 3, h: 2 },
  },
  {
    id: 'total-products',
    type: 'metric_card',
    title: 'Total de Produtos',
    dataSource: 'products',
    icon: '📦',
    config: {
      metric: 'count',
    },
    defaultPosition: { x: 9, y: 4, w: 3, h: 2 },
  },
  {
    id: 'tickets-by-category',
    type: 'pie_chart',
    title: 'Tickets por Categoria',
    dataSource: 'tickets',
    icon: '🏷️',
    config: {
      groupBy: 'category',
      metric: 'count',
    },
    defaultPosition: { x: 0, y: 6, w: 6, h: 4 },
  },
  {
    id: 'tickets-by-product',
    type: 'pie_chart',
    title: 'Tickets por Produto',
    dataSource: 'tickets',
    icon: '📦',
    config: {
      groupBy: 'product',
      metric: 'count',
    },
    defaultPosition: { x: 6, y: 6, w: 6, h: 4 },
  },
];

export const SUPER_ADMIN_WIDGETS = [
  {
    id: 'active-companies',
    type: 'metric_card',
    title: 'Empresas Ativas',
    dataSource: 'companies',
    icon: '🏢',
    config: {
      metric: 'count',
      filters: { isActive: true },
    },
    defaultPosition: { x: 0, y: 0, w: 3, h: 2 },
  },
  {
    id: 'tickets-by-company',
    type: 'bar_chart',
    title: 'Tickets por Empresa',
    dataSource: 'companies',
    icon: '📊',
    config: {
      groupBy: 'company',
      metric: 'tickets_count',
      limit: 10,
    },
    defaultPosition: { x: 0, y: 2, w: 12, h: 4 },
  },
  {
    id: 'users-by-company',
    type: 'bar_chart',
    title: 'Usuários por Empresa',
    dataSource: 'companies',
    icon: '👥',
    config: {
      groupBy: 'company',
      metric: 'users_count',
      limit: 10,
    },
    defaultPosition: { x: 0, y: 6, w: 6, h: 4 },
  },
  {
    id: 'customers-by-company',
    type: 'bar_chart',
    title: 'Clientes por Empresa',
    dataSource: 'companies',
    icon: '🏢',
    config: {
      groupBy: 'company',
      metric: 'customers_count',
      limit: 10,
    },
    defaultPosition: { x: 6, y: 6, w: 6, h: 4 },
  },
  ...COMPANY_WIDGETS,
];

export const getAvailableWidgets = (isSuperAdmin) => {
  return isSuperAdmin ? SUPER_ADMIN_WIDGETS : COMPANY_WIDGETS;
};
